import { render, staticRenderFns } from "./RemarksInput.vue?vue&type=template&id=d5280220&"
import script from "./RemarksInput.vue?vue&type=script&lang=ts&"
export * from "./RemarksInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports